import * as React from "react";
import Map from "src/share/components/Maps/Map/Map";

const GSPImageDetails = ({ creator, originalDate, lastSeen, photoDNA, sha1, md5, center, radius }) => {
  return (
    <div className="geoseearch-photo__image-details">
      <h2>Image Details:</h2>
      <div className="geoseearch-photo__image-details-container">
        <div className="geosearch-photo__creator">
          <h5>Creator</h5>
          <p>{creator}</p>
        </div>
        <div className="geosearch-photo__original-date">
          <h5>Original Date</h5>
          <p>{originalDate}</p>
        </div>
        <div className="geosearch-photo__last-seen">
          <h5>Last Seen</h5>
          <p>{lastSeen}</p>
        </div>
        <div className="geosearch-photo__photo-dna">
          <h5>Photo DNA</h5>
          <p className="hyphenate">{photoDNA}</p>
        </div>
        <div className="geosearch-photo__sha1">
          <h5>SHA-1</h5>
          <p className="hyphenate">{sha1}</p>
        </div>
        <div className="geosearch-photo__md5">
          <h5>MD5</h5>
          <p className="hyphenate">{md5}</p>
        </div>
        <div className="geosearch-photo__map">
          <h5>Location</h5>
          {center.lat && center.lng ? <Map center={center} radius={radius} isMapDisabled={true} useMarker={true} /> : "" }
        </div>
      </div>
    </div>
  );
};

export default GSPImageDetails;



// WEBPACK FOOTER //
// ./src/modules/GeoSearch/Photo/components/GSPImageDetails.tsx